/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'workorder': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M704 416H320a32 32 0 0 0 0 64h384a32 32 0 0 0 0-64zm0 192H320a32 32 0 0 0 0 64h384a32 32 0 0 0 0-64z" _fill="#8a8a8a"/><path pid="1" d="M832 32H192c-52.928 0-96 43.072-96 96v768c0 52.928 43.072 96 96 96h640c52.928 0 96-43.072 96-96V128c0-52.928-43.072-96-96-96zM320 96h384v96H320V96zm544 800a32 32 0 0 1-32 32H192c-17.632 0-32-14.336-32-32V128c0-17.632 14.368-32 32-32h64v96c0 35.296 28.704 64 64 64h384c35.296 0 64-28.704 64-64V96h64c17.664 0 32 14.368 32 32v768z" _fill="#8a8a8a"/>'
  }
})
